import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SplashScreenService {
  private isShowing = new BehaviorSubject<boolean>(false);
  public isShowing$ = this.isShowing.asObservable();

  private messageSubject = new BehaviorSubject<string>(
    'Getting things ready...',
  );
  public message$ = this.messageSubject.asObservable();

  show(message = 'Getting things ready...') {
    this.messageSubject.next(message);
    this.isShowing.next(true);
  }

  updateMessage(message: string) {
    this.messageSubject.next(message);
  }

  hide() {
    this.isShowing.next(false);
  }
}
